import { render, staticRenderFns } from "./createUnit.vue?vue&type=template&id=d887f56e"
import script from "./createUnit.vue?vue&type=script&lang=js"
export * from "./createUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports